import Vue from 'vue'
import Router from 'vue-router'
// import Cookies from 'js-cookie'
// import storage from '@utils/storage/storage'
import Index from '@views/home/Index'
import Home from '@views/home/pages/home'
import routeLogin from './login/index'
import parentLogin from './parentLogin/index'
import user from './user/index'
import envMode from '@/utils/ajax/http'
// 维护
import maintain from '@views/maintain/pages/index'

Vue.use(Router)

let routerConfig = {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Index,
      meta: {
        needLogin: true
      },
      children: [{
        path: 'home',
        component: Home,
        meta: {
          needLogin: true
        }
      }]

    },
    routeLogin,
    parentLogin,
    user,
    {
      path: '/maintain',
      name: 'Maintain',
      component: maintain
    }
  ]
}

let router = new Router(routerConfig)
// let userToken = Cookies.get('tokenInfo')

router.beforeEach((to, from, next) => {
  console.log('object :>> ', to.fullPath)
  if (to.fullPath === '/parentLogin' || to.fullPath === '/parentLogin/') {
    if (process.env.NODE_ENV === 'development') {
      next()
    } else {
      window.location.href = envMode.env.PARENT_URL
    }
    // envMode.env.PARENT_URL
    return
  }
  /* if (to.matched.some(record => record.meta.needLogin)) {
    console.log(userToken)
    if (!userToken) {
      storage.clearAll()
      // Cookies.remove('tokenInfo')
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
    next()
    }
  } else { */
  next()
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js